import React from 'react'
import AssessmentFlow from '@/components/freetool/AssessmentFlow'
import { aqQuestions, aqResponseOptions } from '@/data/asdQuestions'

type Props = {
  backHref?: string
}

const ASDApp: React.FC<Props> = ({ backHref }) => {
  return (
    <AssessmentFlow
      kind="asd"
      title="Autism Spectrum Disorder Assessment Tool"
      sublabel="Based on the Autism Spectrum Quotient (AQ)"
      questions={aqQuestions}
      options={aqResponseOptions}
      gridClass="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3"
      badgeClass="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-sm sm:text-base font-bold"
      theme={{
        from: 'from-indigo-600',
        to: 'to-purple-600',
        dot: 'bg-indigo-600',
      }}
      pdfLogoUrl="/logos/black-horizontal-logo.png"
      backHref={backHref ?? '/adhd-autism-assessment-tool'}
    />
  )
}

export default ASDApp
